import axios from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';

import APIError from '../exceptions/APIError';

export const getFeatureToggleFetcher = async (
  orgSlug: string,
  keys: string[],
) => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/feature-toggle/${orgSlug}/`;
    const params = new URLSearchParams(keys.map((key) => ['keys', key]));

    const {
      data: { data },
    } = await axios.get(url, { params });

    return data;
  } catch (error) {
    if (error.response) throw new APIError(error.response.data?.message, error);
    throw error;
  }
};
